import React from 'react';
import './Input.scss';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', error, ...props }, ref) => {
    return (
      <div className="ui-input-wrapper">
        <input
          ref={ref}
          className={`ui-input ${error ? 'ui-input-error' : ''} ${className}`}
          {...props}
        />
        {error && <span className="ui-input-error-text">{error}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';
